import React from 'react';
import style from '../../css/WhyChooseUs.module.css';
import {
	FaMobileAlt,
	FaShieldAlt,
	FaUserFriends,
	FaMapMarkedAlt,
} from 'react-icons/fa';
import image1 from '../../assets/images/global.png';

function WhyChooseUs() {
	return (
		<section className={style.wrapper}>
			<section className={style.bannerSection}>
				<div className={style.textContainer}>
					<h4 className={style.smallTitle}>Exporest for travel managers</h4>
					<h2 className={style.mainTitle}>
						A smarter corporate travel management solution
					</h2>
					<p className={style.description}>
						Drive program success with an intuitive platform employees love. Get
						leading inventory, 24/7 support, and smart policy controls in one
						solution.
					</p>
					<button className={style.ctaButton}>Get started</button>
				</div>

				<div className={style.imageContainer}>
					<img
						src={image1}
						alt="Corporate travel management interface"
						className={style.bannerImage}
					/>
				</div>
				<div className={style.bannerOverlay}></div>
			</section>

			{/* <div>
				<div className={style.header}>
					<h2 className={style.mainTitle}>Built for Modern Travelers</h2>
					<div className={style.subTitle}>
						<p className={style.emphasis}>One app. Unlimited journeys.</p>
						<span>
							Whether you're booking for yourself or your team, Exporest
							provides an all-in-one platform to plan, manage, and support your
							travel — anytime, anywhere.
						</span>
					</div>
				</div>

				<div className={`${style.card} ${style.purple}`}>
					<FaMobileAlt className={style.icon} />
					<h3 className={style.cardTitle}>Book in 2 Clicks</h3>
					<p className={style.cardText}>
						Our intuitive app interface lets you search, compare, and book
						domestic or international trips in seconds.
					</p>
				</div>

				<div className={`${style.card} ${style.white}`}>
					<FaShieldAlt className={style.icon} />
					<h3 className={style.cardTitle}>Secure, Corporate-Ready Platform</h3>
					<p className={style.cardText}>
						Built with enterprise-grade security and access control. Role-based
						booking permissions, audit trails, and custom billing support
						included.
					</p>
				</div>

				<div className={`${style.card} ${style.green}`}>
					<FaUserFriends className={style.icon} />
					<h3 className={style.cardTitle}>24/7 Human Travel Experts</h3>
					<p className={style.cardText}>
						Speak with a real agent — anytime, anywhere. Whether it's
						last-minute rescheduling or visa help, we’ve got your back.
					</p>
				</div>

				<div className={`${style.card} ${style.orange}`}>
					<FaMapMarkedAlt className={style.icon} />
					<h3 className={style.cardTitle}>
						Explore Custom Tours & Experiences
					</h3>
					<p className={style.cardText}>
						Discover curated business retreats, wellness escapes, adventure
						tours, and team-building trips tailored to your goals.
					</p>
				</div>
			</div> */}
		</section>
	);
}

export default WhyChooseUs;
